// PaymentMethodField.tsx

import { FC, useState } from "react";
import { ChipTab, ChipTabContainer } from "../../../components/Hulabill";
import { Field } from "../../../redux/stepper-data";
import { StepNavProps } from "../StepNavigation";
import { ExtraContentProps } from "../Stepper";
import { PaymentData } from "../../../redux/payment-data";
import { CardForm } from "./CardForm";
import { BankForm } from "./BankForm";
import { PaymentMethodError, SavedPaymentMethod } from "./SavedPaymentMethod";
import { styled } from "@mui/material/styles";

export const CardFormRoot = styled('form')`
  width: 100%;
  margin: 16px 0;
  display: flex;
  flex-direction: column;

  .MuiTextField-root {
    margin: 8px 0;
  }

  > div {
    display: flex;
    gap: 8px;

    > * {
      flex: 1;
    }
  }
`;

export const PaymentMethodField: FC<Field & StepNavProps & ExtraContentProps> = ({
  nextLabel,
  backLabel,
  extraContent,
  onClose,
}) => {
  const [selectedPaymentTypeIndex, setSelectedPaymentTypeIndex] = useState(0);

  const paymentData = extraContent as PaymentData;
  const newMethods = paymentData?.newPaymentMethods || [];
  const selectedMethod = newMethods[selectedPaymentTypeIndex];

  // Detect if we're using Microform v2
  const isMicroform =
    selectedMethod?.tokenizer?.type === 'CyberSourceMicroform' &&
    !!selectedMethod?.tokenizer?.authentication;

  const captureContext = isMicroform
    ? (typeof selectedMethod.tokenizer.authentication === 'string' ? selectedMethod.tokenizer.authentication : "")
    : "";

  const forms: { [key: string]: JSX.Element } = {
    CreditCard: (
      <CardForm
        nextLabel={nextLabel}
        backLabel={backLabel}
        onClose={onClose}
        isMicroform={isMicroform}
        captureContext={captureContext}
      />
    ),
    Check: <BankForm nextLabel={nextLabel} backLabel={backLabel} onClose={onClose} />,
  };

  if (paymentData?.preferredPaymentMethod) {
    return (
      <SavedPaymentMethod
        {...paymentData}
        backLabel={backLabel}
        nextLabel={nextLabel}
        onClose={onClose}
      />
    );
  }

  return (
    <>
      {paymentData?.paymentMethodHeader && (
        <PaymentMethodError>{paymentData.paymentMethodHeader}</PaymentMethodError>
      )}

      {newMethods.length > 1 && (
        <ChipTabContainer shaded>
          {newMethods.map((pm, i) => (
            <ChipTab
              key={i}
              selected={selectedPaymentTypeIndex === i}
              label={pm.name}
              onClick={() => setSelectedPaymentTypeIndex(i)}
            />
          ))}
        </ChipTabContainer>
      )}

      {selectedMethod?.formType && forms[selectedMethod.formType]}
    </>
  );
};